/* SADECE BUTON EKLEYEN BASİT VERSİYON */

const injectSimpleCodButton = () => {
  // Senin orijinal butonunu buluyoruz
  const originalBtn = document.getElementById('premium-bundle-submit');
  
  // Eğer orijinal buton ekrandaysa ve bizim yeşil buton henüz eklenmemişse
  if (originalBtn && !document.getElementById('simple-cod-btn')) {
    
    // Yeni yeşil butonu yarat
    const codBtn = document.createElement('button');
    codBtn.id = 'simple-cod-btn';
    
    // İçindeki yazı ve ikon
    codBtn.innerHTML = `
      <svg style="margin-right:8px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
      KAPIDA ÖDEME İLE AL
    `;
    
    // Tasarım (Yeşil, şık ve mevcut butonla aynı genişlikte)
    codBtn.style.display = 'flex';
    codBtn.style.alignItems = 'center';
    codBtn.style.justifyContent = 'center';
    codBtn.style.width = '100%';
    codBtn.style.padding = '16px';
    codBtn.style.backgroundColor = '#10B981'; // Güzel bir yeşil tonu
    codBtn.style.color = 'white';
    codBtn.style.fontSize = '16px';
    codBtn.style.fontWeight = 'bold';
    codBtn.style.border = 'none';
    codBtn.style.borderRadius = '8px'; // Kenar kıvrımı
    codBtn.style.cursor = 'pointer';
    codBtn.style.marginTop = '12px';
    codBtn.style.transition = 'background-color 0.3s';
    
    // Üzerine gelince rengi hafif koyulaşsın
    codBtn.onmouseover = () => codBtn.style.backgroundColor = '#059669';
    codBtn.onmouseout = () => codBtn.style.backgroundColor = '#10B981';

    // *** EN ÖNEMLİ KISIM ***
    // Tıklandığında senin orijinal butona tıklasın ve aynı yere gitsin
    codBtn.addEventListener('click', (e) => {
      e.preventDefault();
      originalBtn.click(); 
    });

    // Butonu ekrana, orijinal butonun tam altına yerleştir
    originalBtn.parentNode.insertBefore(codBtn, originalBtn.nextSibling);
    
    return true; // Başarıyla eklendi
  }
  return false; // Henüz bulunamadı
};

// Sayfa yüklendiğinde senin gecikmeli gelen orijinal butonunu beklemek için sürekli tarama yapar
const checkInterval = setInterval(() => {
  if (injectSimpleCodButton()) {
    clearInterval(checkInterval); // Butonu bulup ekleyince aramayı durdurur
  }
}, 500); 